// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","TimeInfo":"MtpUGw","fadeInFrames":"_3NuilK"};